/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'health-monitor';
const componentName = 'sctp-health-monitor-config';
const prefix = `${moduleName}.${componentName}`;

export const sectionTitleSctp = `${prefix}.sectionTitleSctp`;
export const clientRequestHeaderInputLabel = `${prefix}.clientRequestHeaderInputLabel`;
export const clientRequestHeaderInputPlaceholder = `${prefix}.clientRequestHeaderInputPlaceholder`;
export const serverResponseDataInputLabel = `${prefix}.serverResponseDataInputLabel`;
export const serverResponseDataInputPlaceholder = `${prefix}.serverResponseDataInputPlaceholder`;

export const ENGLISH = {
    [sectionTitleSctp]: 'SCTP',
    [clientRequestHeaderInputLabel]: 'Client Request Header',
    [clientRequestHeaderInputPlaceholder]: 'Enter Client Request Header',
    [serverResponseDataInputLabel]: 'Server Response Data',
    [serverResponseDataInputPlaceholder]: 'Enter Server Response Data',
};
